var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .983)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 7a3.81 3.81 0 0 0-2.367.81c-.672.516-1.12 1.173-1.384 1.65-.264-.477-.711-1.134-1.384-1.65A3.81 3.81 0 0 0 10.249 7c-2.424 0-4.25 1.964-4.25 4.569 0 2.814 2.279 4.74 5.73 7.654.586.495 1.25 1.056 1.94 1.655a.502.502 0 0 0 .66 0c.69-.599 1.354-1.16 1.94-1.655C19.72 16.308 22 14.383 22 11.569c0-2.605-1.827-4.57-4.25-4.57z",
    stroke: "#212934",
    strokeWidth: 1.23
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.556a4046e84d97afe066cf0e7e195b2d.svg";
export { ForwardRef as ReactComponent };